import { COLORS, getStatusColor } from '@btime/constants'
import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import { compose, path, pathOr, curry } from 'ramda'
import React from 'react'

import { SmallText, Text, Title } from '../../components/presentation/Text'
import { UserAvatar } from '../../components/presentation/Avatar'
import DateText from '../../components/presentation/DateText'
import FlexGrid, { FlexColumn } from '../../components/structure/FlexGrid'
import IconText from '../../components/presentation/IconText'
import Panel from '../../components/structure/Panel'
import Separator from '../../components/helpers/Separator'
import StatusTag, { PRIORITY, STATUS } from './StatusTag'
import TagPresenter from '../tags/TagPresenter'

const LocalIconText = ({ label, icon }) =>
  label && (
    <IconText left color={COLORS.dark3} iconName={icon} label={label} iconSize="1rem" size="p" separatorWeight={3} />
  )

const capitalizePath = curry((capFunc, fields, item) => compose(capFunc, pathOr('', fields))(item))

const ServiceOrderCard = ({ item }) => {
  const customerName = capitalizePath(capitalizeIfLower, ['customer', 'name'], item)
  const placeName = capitalizePath(capitalizeIfLower, ['place', 'name'], item)
  const userName = capitalizePath(capitalizeAllIfLower, ['user', 'name'], item)
  const statusName = path(['status', 'name'], item)

  let title = capitalizePath(capitalizeIfLower, ['checklist', 'name'], item)
  let subTitle = item.yearlyId

  const panelColor = getStatusColor(statusName)

  return (
    <Panel smallPadding borderLeftColor={panelColor}>
      <FlexGrid justify="flex-start" align="flex-start" gutter={0.1}>
        <StatusTag item={item.status} type={STATUS} />
        <StatusTag item={item.priority} type={PRIORITY} />
        <TagPresenter tag={item.tag} />
        <FlexColumn flex={1}>
          <DateText
            size="xsmall"
            bold
            align="right"
            color={COLORS.dark3}
            date={item.scheduling}
            format="DD/MM/YYYY HH:mm"
          />
        </FlexColumn>
      </FlexGrid>
      <Separator weight={3} />
      <SmallText size="xsmall" color={COLORS.dark3}>
        {subTitle}
      </SmallText>
      <Title size="h5" bold>
        {title}
      </Title>

      <Separator />
      <LocalIconText label={placeName} icon="BsBuilding" />
      {!placeName && <LocalIconText label={customerName} icon="BsBuilding" />}
      <Separator weight={2} />
      {!!userName && (
        <FlexGrid justify="flex-start" gutter={0.3}>
          <UserAvatar size="xsmall" user={item.user || {}} />
          <Text color={COLORS.dark3}>{userName}</Text>
        </FlexGrid>
      )}
    </Panel>
  )
}

export default ServiceOrderCard
